import isInstance from './isInstance.js';

const isRegExp = (x) => isInstance(RegExp, x);
export default isRegExp;
